var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "talent_portrait" },
    [
      _vm.portrait_navshow_list && _vm.portrait_navshow_list.length
        ? _c(
            "el-container",
            [
              _c(
                "el-main",
                _vm._l(_vm.portrait_navshow_list, function(item, index) {
                  return _c(item.component, {
                    tag: "component",
                    class: "comp_" + item.id,
                    attrs: { componentData: item.dataObj },
                    on: { trimArray: _vm.trimArray }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-aside",
                { attrs: { width: "150px" } },
                [
                  _c("comm-aside", {
                    attrs: {
                      navList: _vm.portrait_navshow_list,
                      asideActive: _vm.asideActive
                    },
                    on: { goAnchor: _vm.goAnchor }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "noData",
              style: { height: _vm.screenHeight + "px" }
            },
            [
              _c("img", { attrs: { src: _vm.noDataImgUrl, alt: "" } }),
              _c("span", [_vm._v("暂无数据")])
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }